import React from "react";

export default function AllergenFreeSection({
  title,
  highlightWord,
  description,
  subheading,
  features = [],
  note,
  image,
  imageAlt,
}) {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center gap-10">
        {/* LEFT TEXT AREA */}
        <div className="md:w-1/2">
          <h2 className="text-4xl sm:text-5xl font-semibold text-gray-900 leading-snug mb-4">
            {title.split(highlightWord)[0]}
            <span className="text-[#C03CA0] font-bold"> {highlightWord} </span>
            {title.split(highlightWord)[1]}
          </h2>

          <p className="text-gray-700 mb-6">{description}</p>

          <p className="text-lg font-semibold text-gray-900 mb-6">
            {subheading}
          </p>

          {/* ICONS ROW */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-6">
            {features.map((item, index) => (
              <div key={index} className="flex flex-col items-center text-center">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gray-100 mb-3">
                  <img
                    src={item.icon}
                    alt={item.label}
                    width={64}
                    height={64}
                    loading="lazy"
                    decoding="async"
                    className="w-16 h-16 object-contain"
                  />
                </div>
                <p className="font-medium text-gray-800 text-sm sm:text-base">
                  {item.label}
                </p>
              </div>
            ))}
          </div>

          <p className="text-[#C03CA0] text-sm sm:text-base leading-relaxed">
            {note}
          </p>
        </div>

        {/* RIGHT IMAGE AREA */}
        <div className="md:w-1/2 flex justify-center">
          <img
            src={image}
            alt={imageAlt}
            loading="lazy"
            decoding="async"
            className="rounded-xl shadow-md max-w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
}
